<template>
  <el-table-column
    prop="tax_number"
    sortable
    label="Adószám"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.tax_number }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'tax_number',
  };
</script>
